<script lang="ts">
    import Vue from "vue";
    import { Component } from 'vue-facing-decorator';
    import { AlternativeFilterReadModel } from "@Alternatives/AlternativesViews/Domain/readmodels";
    import { AttributeReadModel } from "@Alternatives/Attributes/Domain/readmodels";

    @Component({
        props: {
            propRm: { type: Object, required: true },
            propAttributes: { type: Array, required: true }
        }
    })
    export default class AttributeFilter extends Vue
    {
        get rm(): AlternativeFilterReadModel { return this.$props.propRm as AlternativeFilterReadModel; }
        get attributes(): AttributeReadModel[] { return this.$props.propAttributes as AttributeReadModel[]; }

        get valueRequired(): boolean { return this.rm.Type != "PropertyIsKnown" && this.rm.Type != "PropertyIsUnknown"; }

        get OpText(): string 
        {
            switch (this.rm.Type)
            {
                case "PropertyEq": return "equals";
                case "PropertyNotEq": return "not equals";
                case "PropertyLt": return "less then";
                case "PropertyLte": return "less then or equal";
                case "PropertyGt": return "greater then";
                case "PropertyGte": return "greater then or equal";
                case "PropertyIsKnown": return "is known";
                case "PropertyIsUnknown": return "is unknown";
                case "PropertyContains": return "contains";
                default: return "";
            }
        }

        get headerText(): string 
        {
            const attr = (this.attributes || []).find(a => a.Name == this.rm.Data.Name);

            if (!attr)
            {
                return "Choose attribute...";
            }

            if (!this.rm.Data.Value && this.valueRequired)
            {
                return "Set condition...";
            }

            return `${attr.Name} ${this.OpText} ${this.valueRequired ? this.rm.Data.Value : ''}`;
        }

        deleteFilter()
        {
            this.$emit('deleteFilter', this.rm);
        }
    }
</script>

<template>
    <div class="card" style="display: inline-block;">
        <div @click="rm.IsEdited = true" class="card-header pointer">
            {{headerText}}
        </div>
        <div v-if="rm.IsEdited" class="card-body">
            <div class="form-group">
                <label>Attribute:</label>
                <select v-model="rm.Data.Name" class="form-control">
                    <option :value="null">Choose...</option>
                    <option v-for="attr in attributes" :value="attr.Name">{{attr.Name}}</option>
                </select>
            </div>
            <div class="form-group">
                <label>{{OpText}}:</label>
                <input v-if="valueRequired" type="text" v-model="rm.Data.Value" class="form-control">
            </div>
            <div class="d-flex justify-content-between">
                <div class="dropdown d-inline">
                    <button type="button" class="btn btn-outline-danger" data-toggle="dropdown">
                        Delete
                    </button>
                    <div class="dropdown-menu">
                        <div class="btn-group">
                            <button type="button" class="btn btn-outline-secondary">Cancel</button>
                            <button @click="deleteFilter" type="button" class="btn btn-danger">Confirm</button>
                        </div>
                    </div>
                </div>

                <button @click="rm.IsEdited = false" class="btn btn-primary">Update</button>
            </div>
        </div>
    </div>
</template>      


<style scoped>
</style>